import InfoIcon from "@mui/icons-material/Info";
import CategoryIcon from "@mui/icons-material/Category";
import PhoneIcon from "@mui/icons-material/Phone";
import PersonIcon from "@mui/icons-material/Person";

import AboutUs from "layouts/pages/landing-pages/about-us";
import ContactUs from "layouts/pages/landing-pages/contact-us";
import SearchArtists from "pages/LandingPages/SearchArtists/SearchArtists";
import SignInPage from "layouts/pages/authentication/sign-in";

const routes = [
  {
    name: "About Us",
    icon: <InfoIcon />,
    columns: 1,
    rowsPerColumn: 2,
    route: "/about-us",
    component: <AboutUs />,
    // collapse: [
    //   {
    //     name: "landing pages",
    //     collapse: [
    //       {
    //         name: "about us",
    //         route: "/pages/landing-pages/about-us",
    //         component: <AboutUs />,
    //       },
    //       {
    //         name: "contact us",
    //         route: "/pages/landing-pages/contact-us",
    //         component: <ContactUs />,
    //       },
    //       {
    //         name: "author",
    //         route: "/pages/landing-pages/author",
    //         component: <Author />,
    //       },
    //     ],
    //   },
    //   {
    //     name: "account",
    //     collapse: [
    //       {
    //         name: "sign in",
    //         route: "/pages/authentication/sign-in",
    //         component: <SignIn />,
    //       },
    //     ],
    //   },
    // ],
  },
  // {
  //   name: "Search Artists",
  //   icon: <PersonSearchIcon />,
  //   route:"/search-artists",
  //   component:<SearchArtists/>
  // },
  {
    name: "Category",
    icon: <CategoryIcon />,
    collapse: [
      {
        name: "singer",
        route: "/search-artists",
        component: <SearchArtists />,
      },
      {
        name: "music band",
        route: "/search-artists",
        component: <SearchArtists />,
      },
      {
        name: "dj",
        route: "/search-artists",
        component: <SearchArtists />,
      },
      {
        name: "anchor",
        route: "/search-artists",
        component: <SearchArtists />,
      },
      {
        name: "instrumental",
        route: "/search-artists",
        component: <SearchArtists />,
      },
      {
        name: "standup comedian",
        route: "/search-artists",
        component: <SearchArtists />,
      },
    ],
  },
  {
    name: "contact",
    icon: <PhoneIcon />,
    route: "/contact-us",
    component: <ContactUs />,
  },
  {
    name: "sign in",
    icon: <PersonIcon />,
    route: "/authentication/sign-in",
    component: <SignInPage />,
  },
];

export default routes;
